import { CustomerTypes } from "app/hooks/";
import { concatClassnames } from "shared/utils/concatClassnames";

import { useStandardProductType } from "app/hooks/shared/standard-product/useStandardProductType";
import { useCartContext } from "app/providers/CartProvider";
import CheckoutInfoHeader from "entities/checkout/info-header";
import CheckoutInfoBilling from "features/checkout/info-billing";
import CheckoutInfoBusiness from "features/checkout/info-business";
import CheckoutInfoCheckboxes from "features/checkout/info-checkboxes";
import CheckoutInfoDelivery from "features/checkout/info-delivery";
import CheckoutInfoPersonal from "features/checkout/info-personal";
import CheckoutInfoSwitch from "features/checkout/info-switch";
import InternalNotes from "features/shared/internal-notes";
import { useCheckoutInfoContext } from "pages/checkout/providers/CheckoutInfoProvider";
import { CheckoutMobileSidebarInfos } from "./CheckoutMobileSidebarInfos";
import { HiddenInput } from "./components/HiddenInput";

interface CheckoutInfoInputsProps {
  className?: string;
}

const CheckoutInfoInputs = ({ className = "" }: CheckoutInfoInputsProps) => {
  const { state } = useCheckoutInfoContext();
  const { containsZakelijkProducts } = useCartContext();

  return (
    <section className={concatClassnames("", className)}>
      <CheckoutInfoHeader />

      {!containsZakelijkProducts && <CheckoutInfoSwitch className="gg-mb-5" />}

      <form className="gg-grid gg-grid-cols-12">
        <HiddenInput />
        {state.type === CustomerTypes.PERSONAL ? (
          <CheckoutInfoPersonal className="gg-col-span-12 gg-mb-14" />
        ) : (
          <CheckoutInfoBusiness className="gg-col-span-12 gg-mb-14" />
        )}

        <CheckoutInfoDelivery
          isBusiness={containsZakelijkProducts}
          className="gg-col-span-12 gg-mb-8"
        />

        {!state.isSameAddress && (
          <CheckoutInfoBilling className="gg-col-span-12" />
        )}

        <InternalNotes className="gg-col-span-12 gg-mb-10" />

        <div className="gg-col-span-12 gg-mb-10 xl:gg-hidden">
          <CheckoutMobileSidebarInfos />
        </div>

        <CheckoutInfoCheckboxes className="gg-col-span-12 gg-border-b gg-border-t gg-border-dark-blue-300 gg-py-7" />
      </form>
    </section>
  );
};
export default CheckoutInfoInputs;
